<div
  #wrapperRef
  class="relative grid grid-cols-[20px_1fr_20px] gap-4 rounded-lg border-[1.5px] border-grey-300 bg-white"
  [attr.data-test-id]="`wrapper-${key}`"
  [ngClass]="{
    'grid-cols-[20px_1fr_20px_20px]': isPassword,
    'px-6 py-1': !hasFocus,
    'border-[3px]! border-blue-600! px-[22px] py-0.5':
      hasFocus && !this.field.props?.disabled,
    'border-red-600!':
      form.get('' + field.key)?.touched && form.get('' + field.key)?.invalid,
  }"
>
  <div class="flex items-center justify-center">
    @if (field.type === 'email') {
      <svg-icon
        src="assets/icons/Communication/mail-02.svg"
        data-test-id="emailIcon"
        [ngClass]="{
          'text-red-600!':
            form.get('' + field.key)?.touched &&
            form.get('' + field.key)?.invalid,
          'text-grey-500!': field.props?.disabled,
        }"
      />
    }
    @if (field.key === 'confirmationCode') {
      <svg-icon
        src="assets/icons/Security/passcode.svg"
        data-test-id="passcodeIcon"
        [ngClass]="{
          'text-red-600!':
            form.get('' + field.key)?.touched &&
            form.get('' + field.key)?.invalid,
          'text-grey-500!': field.props?.disabled,
        }"
      />
    }
    @if (isPassword) {
      <svg-icon
        src="assets/icons/Security/lock-01.svg"
        data-test-id="passwordIcon"
        [ngClass]="{
          'text-red-600!':
            form.get('' + field.key)?.touched &&
            form.get('' + field.key)?.invalid,
          'text-grey-500!': field.props?.disabled,
        }"
      />
    }
  </div>

  <div>
    <p
      class="text-xs leading-[18px] text-blue"
      [ngClass]="{
        'text-red-600!':
          form.get('' + field.key)?.touched &&
          form.get('' + field.key)?.invalid,
        'text-grey-500!': field.props?.disabled,
      }"
    >
      {{ field.props?.label }}
    </p>
    <div class="leading-[22px] text-grey placeholder-grey-400">
      <ng-container #fieldComponent />
    </div>
  </div>
  <div class="flex items-center justify-center">
    @if (this.formControl.value && this.formControl.value.length > 0) {
      <button
        class="flex"
        type="button"
        data-test-id="clearButton"
        (click)="clearField()"
      >
        <svg-icon
          class="cursor-pointer"
          src="/assets/icons/General/x-circle.svg"
          [ngClass]="{
            'cursor-default! text-grey-500!': field.props?.disabled,
          }"
        />
      </button>
    }
  </div>
  @if (isPassword) {
    <div class="flex items-center justify-center">
      <button
        class="flex"
        type="button"
        data-test-id="passwordVisibilityButton"
        (click)="togglePasswordVisibility()"
      >
        <svg-icon
          class="cursor-pointer"
          [src]="
            this.field.type === 'password'
              ? 'assets/icons/General/eye-off.svg'
              : 'assets/icons/General/eye.svg'
          "
          [ngClass]="{
            'cursor-default! text-grey-500!': field.props?.disabled,
          }"
        />
      </button>
    </div>
  }
</div>
@if (formControl.errors && showError) {
  <formly-validation-message
    class="-mb-[1.4em] block text-sm text-red-600"
    [attr.data-test-id]="`errorMessage-${key}`"
    [field]="field"
  />
}
